const isObjectEmpty = (moduleToBgChange) => {
	return Object.keys(moduleToBgChange).length === 0 && moduleToBgChange.constructor === Object;
};

export default isObjectEmpty;
